import "reflect-metadata"
import { injectable } from 'inversify-props'
import { LojaServiceAdapter } from '@/usecases'
import { 
	get, 
	find,
	create,
	update,
	patch,
	remove,
	changeLoja,
	buscarParametrosControlPayDaLoja,
	gravarParametrosControlPay,
	desvincularLoja,
	vincularLojas,
} from '@/api/lojas'
import { Deposito, FormLoja, Page, PdvComOperador, PdvsComValores, TurnoDetalhado, ParametrosControlPay, LojaDoPdv, Loja } from '@/models'
import request from "@/common/request"
import { AxiosRequestConfig } from "axios"

@injectable()
export class LojaService implements LojaServiceAdapter {
	get = async (id: string, params?: AxiosRequestConfig) => await get(id, params)
	find = async (params?: any, config?: AxiosRequestConfig) => await find(params, config)
	create = async (loja: FormLoja) => await create(loja)
	update = async (loja: FormLoja) => await update(loja)	
	patch = async (loja: FormLoja) => await patch(loja)
	remove = async (id: string): Promise<void> => await remove(id)
	changeLoja = async (loja: Partial<FormLoja>, rota: string) => await changeLoja(loja, rota)
	vincularLojas = async (loja: Partial<FormLoja>) => await vincularLojas(loja)
	desvincularLoja = async (lojaId: string, lojaDesvincular: string) => await desvincularLoja(lojaId, lojaDesvincular)

	getDepositoDaLoja(id: string, params?: AxiosRequestConfig): Promise<Page<Deposito>> {
		return request.get(`/lojas/${id}/depositos`, params)
	}
	getPdvsDaLoja(id: string, params?: AxiosRequestConfig): Promise<Page<PdvComOperador>> {
		return request.get(`/lojas/${id}/pdvs`, params)
	}

	getPdvsDaLojaComValores(id: string, somenteAbertos: boolean, params?: AxiosRequestConfig): Promise<Page<PdvsComValores>> {
		return request.get(`/turno-venda/valores-turno/${id}/${somenteAbertos}`, params)
	}
	getTurnoDetalhado(idTurno: string, params?: AxiosRequestConfig): Promise<Page<TurnoDetalhado>> {
		return request.get(`/turno-venda/turno-detalhado/${idTurno}`, params)
	} 

	findLojaDaTabela(tabelaId: string,  params?: any): Promise<Page<LojaDoPdv>> {
		return request.get(`/lojas/${tabelaId}/tabela`, { params })		
	}

	findLojaByPdv(id: string, params?: AxiosRequestConfig): Promise<Loja> {
		return request.get(`/lojas/${id}/loja`, { params })
	}

	buscarParametrosControlPay = async (lojaId: string) => await buscarParametrosControlPayDaLoja(lojaId)
	gravarParametrosControlPay = async (lojaId: string, parametrosControlPay: ParametrosControlPay) => await gravarParametrosControlPay(lojaId, parametrosControlPay)

	findLojasVinculadasByLojaId(params: string, config?: AxiosRequestConfig): Promise<Page<Loja>> {
		return request.get(`/lojas/lojas-vinculadas`, {params, ...config})
	}
}